module.exports = __webpack_public_path__ + "static/img/fr.14f4651.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/fr.png
// module id = U7Av
// module chunks = 18